import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/runner/work/tiagoj.co/tiagoj.co/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line
import { EventImpl } from "@/models/Event";
import { defineComponent, ref, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { formatDistance, parseISO } from "date-fns";
import { ptBR, enUS } from "date-fns/locale";
import get from "axios";
var apiUriUser = "https://api.github.com/users/tiagojco";
var apiUriEvents = "https://api.github.com/users/tiagojco/events";
var apiToken = "8257823a5a338111ca57dce541adea39bb74fb4f";
export default defineComponent({
  name: "GithubActivity",
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _useI18n, t, locale, user, events;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _useI18n = useI18n(), t = _useI18n.t, locale = _useI18n.locale;
              user = ref({});
              events = reactive([ref(0)]); // query user api

              _context.next = 5;
              return get(apiUriUser, {
                headers: {
                  Authorization: "token " + apiToken
                }
              }).then(function (response) {
                // handle success
                user = ref(response.data);
              }).catch(function (error) {
                // handle error
                console.error(error);
              }).then(function () {
                // always executed
                console.info("github user done.");
              });

            case 5:
              _context.next = 7;
              return get(apiUriEvents, {
                headers: {
                  Authorization: "token " + apiToken
                }
              }).then(function (response) {
                // handle success
                events = reactive(response.data.map(function (eventRaw) {
                  return new EventImpl(eventRaw);
                }));
              }).catch(function (error) {
                // handle error
                console.error(error);
              }).then(function () {
                // always executed
                console.info("github events done.");
              });

            case 7:
              return _context.abrupt("return", {
                user: user,
                events: events,
                t: t,
                locale: locale,
                fromNow: function fromNow(relativeDate) {
                  var l = locale.value == "pt-br" ? ptBR : enUS;
                  return formatDistance(parseISO(relativeDate), new Date(), {
                    locale: l
                  });
                }
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
});